import { Typography } from '@mui/material';
import { ExtendedList } from '@procureai/ui-mui';
import { isEmpty, isNil, isNotNil } from 'ramda';
import { useTranslation } from 'react-i18next';

import { SvbrgExtendedLineItemsCheck } from '@/generated/gql/graphql';
import { I18nNamespace } from '~/common/types';

import { ExtendedLineItem } from './ExtendedLineItem';

interface ExtendedLineItemAccordionProps {
  formId: string;
  checks: SvbrgExtendedLineItemsCheck[] | null;
}

export const ExtendedLineItemAccordion = ({ checks }: ExtendedLineItemAccordionProps) => {
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeExtendedLineItemsCheckStep' });

  if (isNil(checks) || isEmpty(checks)) {
    return (
      <Typography variant="body2" color="text.secondary">
        {t('noChecks')}
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t('title')}
      </Typography>

      {isNotNil(checks) && (
        <ExtendedList>
          {checks.map((check) => (
            <ExtendedLineItem key={check.id} check={check} />
          ))}
        </ExtendedList>
      )}
    </>
  );
};
